import React, { Component } from "react";
import QrReader from "react-qr-reader";
import QRCode from "qrcode.react";

import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      delay: 300,
      result: "",
      qrValue: "",
      width: 400
    };
    this.handleScan = this.handleScan.bind(this);
  }
  handleScan(data) {
    if (data) {
      this.setState({
        result: data + "\n" + this.state.result
      });
    }
  }
  handleError(err) {
    console.error(err);
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  updateDimensions() {
    this.setState({ width: this.container.offsetWidth });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div style={{ width: "50%" }} ref={ref => (this.container = ref)}>
          <div style={{ display: "flex" }}>
            <QrReader
              delay={this.state.delay}
              onError={this.handleError}
              onScan={this.handleScan}
              style={{ flex: 1 }}
            />
            <textarea style={{ flex: 1 }} value={this.state.result} />
          </div>
          <div style={{ display: "flex" }}>
            <textarea
              style={{ flex: 1 }}
              value={this.state.qrValue}
              onChange={e => this.setState({ qrValue: e.target.value })}
            />
            <div style={{ flex: 1 }}>
              <QRCode
                value={this.state.qrValue}
                size={this.state.width / 2}
                level={"L" || "M" || "Q" || "H"}
                bgColor={"#FFFFFF"}
                fgColor={"#000000"}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js